<template>
    <div class="customer-flows-repeater" style="width: 100%">
        <div class="customer-flows-repeater__items">
            <transition-group name="fade-down">
                <CustomerFlowForm
                    v-for="(flow, index) in customerFlows"
                    :key="index"
                    v-model="customerFlows[index]"
                    :schema="schema"
                    :flows="flows"
                    :can-delete="customerFlows.length > 1"
                    @delete="onDelete"
                />
            </transition-group>
        </div>
        <button
            :class="['button', 'button--fullwidth']"
            style="margin: 0 auto"
            type="button"
            @click="addFlow"
        >
            + Add another customer flow
        </button>
    </div>
</template>

<script>
import CustomerFlowForm from '../CustomerFlowForm/CustomerFlowForm';

export default {
    name: 'CustomerFlowsRepeater',
    components: {
        CustomerFlowForm,
    },
    props: {
        schema: {
            type: Object,
            required: true,
        },
        flows: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            customerFlows: [],
            initialFlow: {
                flow: undefined,
                is_integration: false,
                is_main: false,
                role: undefined,
                type_productions: undefined,
            },
        };
    },

    watch: {
        customerFlows: {
            deep: true,
            handler() {
                this.update(this.customerFlows);
            },
        },
    },

    mounted() {
        this.addFlow();
    },

    methods: {
        addFlow() {
            this.customerFlows.push({ ...this.initialFlow });
        },
        update(event) {
            this.$emit('update:modelValue', event);
        },
        onDelete(event) {
            this.customerFlows.splice(this.customerFlows.indexOf(event), 1);
        },
    },
};
</script>
